<template>
  <div>
    <div class="text-lg font-bold mb-4">{{$t('main.landscaping')}}</div>

    <div
      v-if="landscaping.mainElement"
      class="text-xl mb-4"
    >
      <div class="element-item-list">
        <div class="element-item">
          <div class="element-group flex justify-between items-center mb-4">
            <div class="text-xl">{{$t('main.base')}}</div>
            <div
              v-if="
                        landscaping.mainElement.total &&
                        settings.with_calc_price == 1 &&
                        !isComplectation
                      "
              class="font-bold text-xl mt-2 text-right whitespace-nowrap"
            >
              {{ $toCurrency(landscaping.mainElement.total) }}
            </div>
            <button
              v-if="isComplectation"
              class="font-light"
              @click="
                      $store.dispatch(
                        'clientOrder/removeLandscaping',
                        'mainElement'
                      )
                    "
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="element-detail flex justify-between">
            <div class="image">
              <div class="image-wrapper">
                <div
                  class="image-src"
                  :style="{
                          backgroundImage: `url(${landscaping.mainElement.image})`,
                        }"
                ></div>
              </div>
            </div>
            <div class="detail w-full text-sm">
              <div class="flex justify-between">
                <div>
                  <span class="font-bold">{{$t('main.name')}}: </span>
                  <span>{{ landscaping.mainElement.name }}</span>
                </div>
                <div
                  class="landscaping-price whitespace-nowrap"
                  v-if="settings.with_calc_price == 1"
                >
                  {{ $toCurrency(parseFloat(landscaping.mainElement.size.price)) }}
                  <span v-if="
                            landscaping.mainElement.element_group_slug ==
                              'plate-fill' ||
                            landscaping.mainElement.element_group_slug ==
                              'stripe'
                          ">
                    /м<sup>3</sup>
                  </span>
                  <span v-if="
                            landscaping.mainElement.element_group_slug ==
                              'paving' ||
                            landscaping.mainElement.element_group_slug ==
                              'pour' ||
                            landscaping.mainElement.element_group_slug ==
                              'grass'
                          ">
                    /м<sup>2</sup>
                  </span>
                </div>
              </div>
              <div>
                <span class="font-bold">{{$t('main.article')}}: </span>
                <span>{{ landscaping.mainElement.article }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                <span v-if="landscaping.mainElement.element_group_slug == 'paving'&&landscaping.mainElement.fact_sizes">{{landscaping.mainElement.fact_sizes}}</span>
                <span v-else-if="
                          landscaping.mainElement.element_group_slug ==
                            'plate-ready' ||
                          landscaping.mainElement.element_group_slug == 'paving'
                        ">
                  {{ landscaping.mainElement.size.width }} x
                  {{ landscaping.mainElement.size.length }} x
                  {{ landscaping.mainElement.size.height }}
                </span>
                <span v-if="
                          landscaping.mainElement.element_group_slug ==
                            'plate-fill' ||
                          landscaping.mainElement.element_group_slug == 'stripe'
                        ">{{ landscaping.mainElement.size.width }} x
                  {{ landscaping.mainElement.size.length }}</span>

              </div>

              <div v-if="
                        landscaping.mainElement.element_group_slug ==
                          'plate-fill' ||
                        landscaping.mainElement.element_group_slug == 'stripe'
                      ">
                <span class="font-bold">{{$t('client.complectation.height_under_earth')}}: </span>
                <span>{{ landscaping.mainElement.size.height }}</span>
              </div>
              <div v-if="
                        landscaping.mainElement.element_group_slug ==
                          'plate-fill' ||
                        landscaping.mainElement.element_group_slug == 'stripe'
                      ">
                <span class="font-bold">{{$t('client.complectation.deep_in_earth')}}: </span>
                <span>{{ landscaping.mainElement.size.depth }}</span>
              </div>
              <div v-if="
                        landscaping.mainElement.element_group_slug == 'stripe'
                      ">
                <span class="font-bold">{{$t('client.complectation.width_sm')}}: </span>
                <span>{{ landscaping.mainElement.thickness }}</span>
              </div>
              <div v-if="
                        landscaping.mainElement.element_group_slug !=
                        'plate-ready'
                      ">
                <span
                  class="font-bold"
                  v-html="$t('client.complectation.square')+':'"
                >
                </span>
                <span>{{ landscaping.mainElement.square }}</span>
              </div>
              <div v-if="
                        landscaping.mainElement.element_group_slug ==
                          'plate-fill' ||
                        landscaping.mainElement.element_group_slug == 'stripe'
                      ">
                <span
                  class="font-bold"
                  v-html="$t('client.complectation.volume')+':'"
                > </span>
                <span>{{ landscaping.mainElement.volume }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.type')}}: </span>
                <span>{{ landscaping.mainElementType.title }}</span>
              </div>
              <div
                v-if="
                        parseFloat(landscaping.mainElement.base_price_preparation)
                      "
                class="flex justify-between"
              >
                <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                <span>{{ $toCurrency(landscaping.mainElement.base_price_preparation) }}/м<sup>2</sup></span>
              </div>
              <div
                v-if="
                        landscaping.mainElement.total &&
                        settings.with_calc_price == 1 &&
                        isComplectation
                      "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.mainElement.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="landscaping.facing_top"
      class="text-xl mb-4 border-blue-top"
    >
      <div class="element-item-list">
        <div class="element-item">
          <div class="element-group flex justify-between items-center mb-4">
            <div class="text-xl">{{$t('main.facing_top')}}</div>
            <div
              v-if="
                        landscaping.facing_top.total &&
                        settings.with_calc_price == 1 &&
                        !isComplectation
                      "
              class="font-bold text-xl mt-2 text-right whitespace-nowrap"
            >
              {{ $toCurrency(landscaping.facing_top.total) }}
            </div>
            <button
              v-if="isComplectation"
              class="font-light"
              @click="
                      $store.dispatch(
                        'clientOrder/removeLandscaping',
                        'facing_top'
                      )
                    "
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="element-detail flex justify-between">
            <div class="image">
              <div class="image-wrapper">
                <div
                  class="image-src"
                  :style="{
                          backgroundImage: `url(${landscaping.facing_top.image})`,
                        }"
                ></div>
              </div>
            </div>
            <div class="detail w-full pl-4 text-sm">
              <div class="flex justify-between">
                <div>
                  <span class="font-bold">{{$t('main.name')}}: </span>
                  <span>{{ landscaping.facing_top.name }}</span>
                </div>
                <div
                  class="whitespace-nowrap"
                  v-if="settings.with_calc_price == 1"
                >
                  {{ $toCurrency(parseFloat(landscaping.facing_top.size.price)) }}
                  /м<sup>2</sup>
                </div>
              </div>
              <div>
                <span class="font-bold">{{$t('main.article')}}: </span>
                <span>{{ landscaping.facing_top.article }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                <span v-if="landscaping.facing_top.fact_sizes">
                  {{ landscaping.facing_top.fact_sizes }}
                </span>
                <span v-else>
                  {{ landscaping.facing_top.size.width }} x
                  {{ landscaping.facing_top.size.length }} x
                  {{ landscaping.facing_top.size.height }}
                </span>
              </div>
              <div>
                <span
                  class="font-bold"
                  v-html="$t('client.complectation.square')+':'"
                >
                </span>
                <span>{{ landscaping.facing_top.square }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.type')}}: </span>
                <span>{{ landscaping.facing_top.type_name }}</span>
              </div>

              <div
                v-if="
                        landscaping.facing_top.total &&
                        settings.with_calc_price == 1 &&
                        isComplectation
                      "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.facing_top.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="landscaping.facing_side"
      class="text-xl mb-4 border-blue-top"
    >
      <div class="element-item-list">
        <div class="element-item">
          <div class="element-group flex justify-between items-center mb-4">
            <div class="text-xl">{{$t('main.facing_side')}}</div>
            <div
              v-if="
                        landscaping.facing_side.total &&
                        settings.with_calc_price == 1 &&
                        !isComplectation
                      "
              class="font-bold text-xl mt-2 text-right"
            >
              {{ $toCurrency(landscaping.facing_side.total) }}
            </div>
            <button
              v-if="isComplectation"
              class="font-light"
              @click="
                      $store.dispatch(
                        'clientOrder/removeLandscaping',
                        'facing_side'
                      )
                    "
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="element-detail flex">
            <div class="image">
              <div class="image-wrapper">
                <div
                  class="image-src"
                  :style="{
                          backgroundImage: `url(${landscaping.facing_side.image})`,
                        }"
                ></div>
              </div>
            </div>
            <div class="detail w-full pl-4 text-sm">
              <div class="flex justify-between">
                <div>
                  <span class="font-bold">{{$t('main.name')}}: </span>
                  <span>{{ landscaping.facing_side.name }}</span>
                </div>
                <div
                  class="whitespace-nowrap"
                  v-if="settings.with_calc_price == 1"
                >
                  {{ $toCurrency(parseFloat(landscaping.facing_side.size.price)) }}
                  /м<sup>2</sup>
                </div>
              </div>
              <div>
                <span class="font-bold">{{$t('main.article')}}: </span>
                <span>{{ landscaping.facing_side.article }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                <span v-if="landscaping.facing_side.fact_sizes">
                  {{ landscaping.facing_side.fact_sizes }}
                </span>
                <span v-else>
                  {{ landscaping.facing_side.size.width }} x
                  {{ landscaping.facing_side.size.length }} x
                  {{ landscaping.facing_side.size.height }}
                </span>
              </div>
              <div>
                <span
                  class="font-bold"
                >
                  {{ $t('client.complectation.square') }}:
                </span>
                <span>{{ landscaping.facing_side.square }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.type')}}: </span>
                <span>{{ landscaping.facing_side.type_name }}</span>
              </div>

              <div
                v-if="
                        landscaping.facing_side.total &&
                        settings.with_calc_price == 1 &&
                        isComplectation
                      "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.facing_side.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="landscaping.fillElement"
      class="text-xl mb-4 border-blue-top"
    >
      <div class="element-item-list">
        <div class="element-item">
          <div class="element-group flex justify-between items-center mb-4">
            <div class="text-xl">{{$t('main.filling')}}</div>
            <div
              v-if="
                        landscaping.fillElement.total &&
                        settings.with_calc_price == 1 &&
                        !isComplectation
                      "
              class="font-bold text-xl mt-2 text-right"
            >
              {{ $toCurrency(landscaping.fillElement.total) }}
            </div>
            <button
              v-if="isComplectation"
              class="font-light"
              @click="
                      $store.dispatch(
                        'clientOrder/removeLandscaping',
                        'fillElement'
                      )
                    "
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="element-detail flex justify-between">
            <div class="image">
              <div class="image-wrapper">
                <div
                  class="image-src"
                  :style="{
                          backgroundImage: `url(${landscaping.fillElement.image})`,
                        }"
                ></div>
              </div>
            </div>
            <div class="detail w-full pl-4 text-sm">
              <div class="flex justify-between">
                <div>
                  <span class="font-bold">{{$t('main.name')}}: </span>
                  <span>{{ landscaping.fillElement.name }}</span>
                </div>
                <div
                  class="whitespace-nowrap"
                  v-if="settings.with_calc_price == 1"
                >
                  {{ $toCurrency(parseFloat(landscaping.fillElement.size.price)) }}
                  /м<sup>2</sup>
                </div>
              </div>
              <div>
                <span class="font-bold">{{$t('main.article')}}: </span>
                <span>{{ landscaping.fillElement.article }}</span>
              </div>

              <div>
                <span
                  class="font-bold"
                  v-html="$t('client.complectation.square')+': '"
                >
                </span>
                <span>{{ landscaping.fillElement.square }}</span>
              </div>
              <div
                class="flex justify-between"
                v-if="parseFloat(landscaping.fillElement.base_price_preparation)"
              >
                <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                <span>{{ $toCurrency(landscaping.fillElement.base_price_preparation) }}/м<sup>2</sup></span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.type')}}: </span>
                <span>{{ landscaping.fillElement.type_name }}</span>
              </div>

              <div
                v-if="
                        landscaping.fillElement.total &&
                        settings.with_calc_price == 1 &&
                        isComplectation
                      "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.fillElement.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="landscaping.borderElement"
      class="text-xl mb-4 border-blue-top"
    >
      <div class="element-item-list">
        <div class="element-item">
          <div class="element-group flex justify-between items-center mb-4">
            <div class="text-xl">{{$t('client.complectation.border')}}</div>
            <div
              v-if="
                    landscaping.borderElement.total &&
                    settings.with_calc_price == 1 &&
                    !isComplectation
                "
              class="font-bold text-xl mt-2 text-right"
            >
              {{ $toCurrency(landscaping.borderElement.total) }}
            </div>
            <button
              v-if="isComplectation"
              class="font-light"
              @click="
                      $store.dispatch(
                        'clientOrder/removeLandscaping',
                        'borderElement'
                      )
                    "
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="element-detail flex justify-between">
            <div class="image">
              <div class="image-wrapper">
                <div
                  class="image-src"
                  :style="{
                          backgroundImage: `url(${landscaping.borderElement.image})`,
                        }"
                ></div>
              </div>
            </div>
            <div class="detail w-full pl-4 text-sm">
              <div class="flex justify-between">
                <div>
                  <span class="font-bold">{{$t('main.name')}}: </span>
                  <span>{{ landscaping.borderElement.name }}</span>
                </div>
                <div
                  class="whitespace-nowrap"
                  v-if="settings.with_calc_price == 1"
                >
                  {{ $toCurrency(parseFloat(landscaping.borderElement.size.price)) }}
                  /{{$t('main.m_p')}}
                </div>
              </div>
              <div>
                <span class="font-bold">{{$t('main.article')}}: </span>
                <span>{{ landscaping.borderElement.article }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                <span>
                  {{ landscaping.borderElement.size.width }} x
                  {{ landscaping.borderElement.size.length }} x
                  {{ landscaping.borderElement.size.height }}
                </span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.metraz')}}: </span>
                <span>{{ landscaping.borderElement.perimeter }}</span>
              </div>
              <div>
                <span class="font-bold">{{$t('main.type')}}: </span>
                <span>{{ landscaping.borderElement.type_name }}</span>
              </div>

              <div
                class="flex justify-between gap-1"
                v-if="parseFloat(landscaping.borderElement.base_price_preparation)"
              >
                <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                <span>{{ $toCurrency(landscaping.borderElement.base_price_preparation) }}/{{$t('main.m_p')}}</span>
              </div>

              <div
                v-if="
                    landscaping.borderElement.total &&
                    settings.with_calc_price == 1 &&
                    isComplectation
                "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.borderElement.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    landscaping: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    isComplectation: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.landscaping-price {
  display: flex;
  gap: 0;
}
</style>
